import React, { useRef, useState, useEffect } from "react";
import {
  Box,
  Modal,
  Typography,
  Button,
  TextField,
  Grid,
} from "@mui/material";
import Map from "./DsMap";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: 520,
  maxHeight: "90vh",
  overflowY: "auto",
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 2,
};

export default function DisasterSiteAddModal(props) {
  const nameRef = useRef(null);
  const addrRef = useRef(null);
  const latRef = useRef(null);
  const lonRef = useRef(null);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    if (props.open) {
      if (nameRef.current) nameRef.current.value = "";
      if (addrRef.current) addrRef.current.value = "";
      if (latRef.current) latRef.current.value = "";
      if (lonRef.current) lonRef.current.value = "";
    }
  }, [props.open]);

  const getlocaddr = (rlat, rlon, raddr) => {
    if (latRef.current) latRef.current.value = rlat;
    if (lonRef.current) lonRef.current.value = rlon;
    if (addrRef.current) addrRef.current.value = raddr || "";
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const name = nameRef.current?.value?.trim() || "";
    const addr = addrRef.current?.value?.trim() || "";
    const lat = latRef.current?.value?.trim() || "";
    const lon = lonRef.current?.value?.trim() || "";
    if (!name) {
      alert("현장명을 입력해주세요.");
      return;
    }
    if (!addr || !lat || !lon) {
      alert("지도에서 위치를 클릭하여 주소와 좌표를 입력해주세요.");
      return;
    }
    setSubmitting(true);
    try {
      const res = await fetch(`${props.apiAddr}/post/siteadd`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          dsid: props.dsid,
          name,
          addr,
          lat,
          lon,
        }),
      });
      const data = await res.json();
      if (data && data.result === "success") {
        alert("현장이 추가되었습니다.");
        props.onSuccess();
      } else {
        alert("현장 추가에 실패했습니다.");
      }
    } catch (err) {
      console.error(err);
      alert("현장 추가 중 오류가 발생했습니다.");
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <Modal open={props.open} onClose={props.onClose} aria-labelledby="site-add-modal-title">
      <Box sx={style}>
        <Typography id="site-add-modal-title" variant="h6" color="gray" textAlign="center" mb={1}>
          재난현장 추가
        </Typography>
        <form onSubmit={handleSubmit}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <TextField
                inputRef={nameRef}
                label="현장명"
                size="small"
                fullWidth
                required
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <TextField
                inputRef={addrRef}
                label="주소(지도 클릭 시 자동입력)"
                size="small"
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                inputRef={latRef}
                label="위도(지도 클릭 시 자동입력)"
                size="small"
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={6}>
              <TextField
                inputRef={lonRef}
                label="경도(지도 클릭 시 자동입력)"
                size="small"
                fullWidth
                InputLabelProps={{ shrink: true }}
              />
            </Grid>
            <Grid item xs={12}>
              <Typography variant="caption" color="text.secondary" display="block" sx={{ mb: 0.5 }}>
                지도에서 위치를 클릭하거나 검색하여 주소·좌표를 입력하세요.
              </Typography>
            </Grid>
            <Grid item xs={12} id="mapcntr_site" sx={{ height: 280 }}>
              {props.open && (
                <Map
                  containerId="mapcntr_site"
                  mapId="dsmap_site"
                  clickedvalue={getlocaddr}
                />
              )}
            </Grid>
            <Grid item xs={12} container justifyContent="center" gap={1} sx={{ mt: 1 }}>
              <Button type="submit" variant="contained" disabled={submitting}>
                등록
              </Button>
              <Button type="button" variant="outlined" onClick={props.onClose}>
                취소
              </Button>
            </Grid>
          </Grid>
        </form>
      </Box>
    </Modal>
  );
}
